import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { EfectivoListComponent } from './efectivo-list.component';
import { EfectivoService } from '../../../services/finanzas/efectivo/efectivo.service';

@Component({
    selector: 'convfact-efectivodelete',
    templateUrl: './efectivo-dialog-delete.component.html',
    styleUrls: ['../bancos/bankaccount.component.css'],
    standalone: false
})
export class EfectivoDialogDeleteComponent {

  public uid: string = this.data.uid;
  public response_message: string;
  public response_error: boolean;

  constructor(
    public dialogRef: MatDialogRef<EfectivoListComponent>,
    public efectivoService: EfectivoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
  ) { }

  public delete() {
    this.efectivoService.delete(this.uid)
      .then(res => {
        this.response_message = "La caja/efectivo se ha eliminado correctamente";
        this.response_error = false;
      }).catch(err => {
        this.response_message = "Ha ocurrido un error al eliminar la caja/efectivo";
        this.response_error = true;
      });
  }

  public closeDialog() {
    this.dialogRef.close();
  }
}
